import { FSA } from "../constants";

export const CANCEL_INTERVAL = "SCHEDULE_CANCEL_INTERVAL";
export const cancelInterval = (): FSA => ({ type: CANCEL_INTERVAL });
